import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux'
import renderElements from 'components/Canvas/renderer/redux/elementReducer'
import auth from './auth/reducer'
import preferences from './preferences/reducer'
import snackBar from './snackbar/snackBarReducer';
import elements from './elements/reducer'
import storeTemplates from './storeTemplates/reducer'
import canvas from './canvas/reducer'
import theme from './theme/reducer'
import intl from './intl/reducer'
import storeLocator from './storeLocator/reducer'
import preview from './preview/previewReducer'

export default combineReducers({
  auth,
  canvas,
  storeLocator,
  preview,
  theme,
  renderElements,
  intl,
  preferences,
  elements,
  storeTemplates,
  routing: routerReducer,
  snackBar,
})



// WEBPACK FOOTER //
// ./src/store/rootReducer.js